<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getExternalCustomerUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">外部客户账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['S'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateExternalCustomerUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getExternalCustomerUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <ExternalCustomerUserEdit ref="externalCustomerUserModal" />
        <BlackUserListModal ref="blackUserListModal"/>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat, getapprovalFormatOptions } from '@/libs/baseModelFormat';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import ExternalCustomerUserEdit from './externalCustomer-user-edit';
import { getExternalCustomerUserList } from '@/api/modules/account-management/externalCustomer-user-management';
import BlackUserListModal from '@/view/seedFarm-management/seedFarm-member-black-list/seedFarm-member-black-list-modal.vue';

export default {
    name: 'ExternalCustomerUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        ExternalCustomerUserEdit,
        BlackUserListModal
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 30, align: 'center' },
                    { title: '会员号', key: 'userName', width: 80, align: 'center' },
                    { title: '申请人', key: 'userExternalCustomerName', width: 100, align: 'center' },
                    // { title: '职务', key: 'userExternalCustomerJob', width: 80, align: 'center' },
                    // { title: '场名', key: 'userExternalCustomerFieldName', width: 100, align: 'center' },
                    { title: '手机号码', key: 'userExternalCustomerPhone', width: 90, align: 'center' },
                    // { title: '温室面积/㎡', key: 'userExternalCustomerArea',width: 110, align: 'center' },
                    // { title: '花场地址', key: 'userExternalCustomerAddress',width: 250, align: 'center' },
                    { title: '客户经理', key: 'userCustomerManagerName', width: 80, align: 'center' },
                    // { title: '生产种类', key: 'userCustomerManagerProductionType', width: 80, align: 'center' },
                    { title: '省', key: 'regionProvince', align: 'center' },
                    { title: '市', key: 'regionCity', align: 'center' },
                    { title: '区', key: 'regionDist', align: 'center' },
                    { title: '收货地址', key: 'userExternalCustomerFullAddress', width: 300, align: 'center' },
                    // { title: '区域', key: 'areaName', width: 60, align: 'center' },
                    {
                        title: '审核状态',
                        key: 'userExternalCustomerApproval',
                        width: 80,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.userExternalCustomerApproval))
                            ]);
                        }
                    },
                    {
                        title: '客户评价',
                        key: 'reviewsTotal',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', { style:{
                                color:'red'
                            } }, params.row.reviewsTotal>0?'有评价':'');
                        }
                    },
                    {
                        title: '黑名单',
                        key: 'balckUser',
                        align: 'center',
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                    display: params.row.blackUserStatus? 'inline' : 'none',
                                    color: 'red'
                                },
                                on: {
                                    click: () => {
                                        this.showBlackUser(params.row);
                                    }
                                }
                            }, "黑名单");
                        }
                    },
                    { title: '创建时间', key: 'userExternalCustomerCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.userExternalCustomerCreateAt) },
                    {
                        title: '操作',
                        fixed: 'right',
                        key: 'action',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            const text = this.$checkAccessArray(['S', 'G']) ? '编辑' : '查看';
                            const isEdit = this.$checkAccessArray(['S', 'G']);
                            return h('div', {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }
                            }, [
                                h('Button', {
                                    props: {
                                        type: isEdit ? 'primary' : 'info',
                                        size: 'small',
                                        ghost: true
                                    },
                                    style: {
                                        minWidth: '60px',
                                        height: '28px',
                                        lineHeight: '28px',
                                        padding: '0 8px',
                                        fontSize: '12px',
                                        borderRadius: '4px',
                                        border: isEdit ? '1px solid #2d8cf0' : '1px solid #2db7f5',
                                        backgroundColor: isEdit ? 'rgba(45, 140, 240, 0.1)' : 'rgba(45, 183, 245, 0.1)',
                                        color: isEdit ? '#2d8cf0' : '#2db7f5',
                                        touchAction: 'manipulation',
                                        WebkitTapHighlightColor: 'transparent',
                                        WebkitUserSelect: 'none',
                                        userSelect: 'none',
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdateExternalCustomerUser(params.row);
                                        }
                                    }
                                }, text)
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '会员号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '手机号码', type: 'Input', value: '', name: 'userExternalCustomerPhone', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userExternalCustomerName', sql: 'like' },
                    { label: '客户经理', type: 'Input', value: '', name: 'userCustomerManagerName', sql: 'like' },
                    { label: '省', type: 'Input', value: '', name: 'region1.regionName', sql: 'like' },
                    { label: '市', type: 'Input', value: '', name: 'region2.regionName', sql: 'like' },
                    { label: '区', type: 'Input', value: '', name: 'region3.regionName', sql: 'like' },
                    { label: '收货地址', type: 'Input', value: '', name: 'userExternalCustomerFullAddress', sql: 'like' },
                    // { label: '审核状态', type: 'Input', value: '', name: 'userExternalCustomerApproval', sql: 'like' },
                    {
					    label: '审核状态',
					    type: 'Select',
					    value: [],
					    name: 'userExternalCustomerApproval',
					    sql: 'like',
					    options: getapprovalFormatOptions()
                    },
                    { label: '创建时间', type: 'Daterange', value: [], name: 'userExternalCustomerCreateAt', sql: 'dateBetween' },
                    {
                        label: '客户评价',
                        type: 'Select',
                        value: [],
                        name: 'reviewsTotal',
                        sql: 'in',
                        options: [
                            { value: 0, key: '无评价' },
                            { value: 1, key: '有评价' }
                        ]
                    },
                    { 
                        label: '黑名单', 
                        type: 'Select', 
                        value: [], 
                        name: 'black.userStatus',
                        sql: 'in',
                        options: [
                            { value: 1, key: '是' },
                            { value: 0, key: '否' }
                        ]
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.columns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.getExternalCustomerUserTableRecords();
    },
    methods: {
        getExternalCustomerUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
			
            search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
            this.mainTable.tableSearch.filters.enable = true;
            this.mainTable.tableSearch.filters.conditions.push({
			    name: 'memberType',
			    type: 'eq',
			    value: 'F'
            });
            getExternalCustomerUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateExternalCustomerUser() {
            this.$refs.externalCustomerUserModal.showModal();
			
            // this.$router.push({
            //     name: 'externalCustomer-user-edit',
            //     query: {
            //         userExternalCustomerLoginUuid: ''
            //     }
            // });
        },
        onUpdateExternalCustomerUser(externalCustomerUserRow) {
            this.$refs.externalCustomerUserModal.showModal(externalCustomerUserRow.userExternalCustomerLoginUuid, externalCustomerUserRow.blackUserStatus);
            // this.$router.push({
            //     name: 'externalCustomer-user-edit',
            //     query: {
            //         userExternalCustomerLoginUuid: externalCustomerUserRow.userExternalCustomerLoginUuid
            //     }
            // });
        },
        showBlackUser(row){
            if(!row.seedFarmBlackUserUuid) return;
            this.$refs.blackUserListModal.showModal(row.userExternalCustomerLoginUuid, true);
        }
    }
};
</script>

<style scoped>
/* 移动端适配 */
@media screen and (max-width: 768px) {
    /deep/ .ivu-table-cell {
        padding: 8px 4px !important;
    }
    
    /deep/ .ivu-btn-small {
        min-width: 50px !important;
        height: 32px !important;
        line-height: 32px !important;
        padding: 0 6px !important;
        font-size: 12px !important;
        border-radius: 4px !important;
    }
    
    /deep/ .ivu-table-fixed-right {
        right: 0 !important;
        box-shadow: -2px 0 6px rgba(0, 0, 0, 0.1);
    }
    
    /deep/ .ivu-table-fixed-body {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch !important;
    }
}

/* iOS Safari 特殊处理 */
@supports (-webkit-touch-callout: none) {
    /deep/ .ivu-btn {
        -webkit-appearance: none !important;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0) !important;
        -webkit-user-select: none !important;
        user-select: none !important;
        touch-action: manipulation !important;
    }
    
    /deep/ .ivu-btn:active {
        transform: scale(0.98) !important;
        transition: transform 0.1s ease !important;
    }
}

/* 确保按钮在移动端的点击区域足够大 */
/deep/ .ivu-btn-small {
    min-height: 32px !important;
    min-width: 44px !important;
    touch-action: manipulation !important;
    -webkit-tap-highlight-color: transparent !important;
}

/* 优化表格在移动端的显示 */
/deep/ .ivu-table-wrapper {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
}

/deep/ .ivu-table {
    min-width: 800px !important;
}

/* 针对小屏幕的按钮样式优化 */
@media screen and (max-width: 480px) {
    /deep/ .ivu-btn-small {
        min-width: 44px !important;
        height: 36px !important;
        line-height: 36px !important;
        font-size: 11px !important;
        padding: 0 4px !important;
    }
    
    /deep/ .ivu-table-cell {
        padding: 6px 2px !important;
    }
}

/* 针对苹果设备的优化 */
@media screen and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    /deep/ .ivu-btn {
        border-width: 0.5px !important;
        font-weight: 500 !important;
    }
    
    /deep/ .ivu-table-small td {
        height: 40px !important;
    }
}
</style>
